import { createContext, useContext } from 'react';

/**
 * Context to indicate that the current subtree is rendered on an inverted background
 * (e.g. inside a tooltip). Components can use this to adapt their colors accordingly.
 */
export const InvertedColorContext = createContext(false);

export function useInvertedColor() {
    return useContext(InvertedColorContext);
}
